
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import { useEffect, useState } from "react";
import useTable from "../../components/customHelpers/useTable";
import Notify from "../../components/customHelpers/Notify";
import { useHistory } from "react-router-dom";

import { Box, Grid, Paper, TableBody, TableCell, TableRow, TextField } from "@mui/material";
import { useLocation } from "react-router-dom";
import { formatNumber } from "../../utils/utils";
import { statusBadge } from "../statusBadge";

const headCells = [
  { id: "id", label: "Id" },
  { id: "assignTo", label: "Assigned To" },
  { id: "totalPrice", label: "Total Price" },
  { id: "paid", label: "Paid" },
  { id: "unpaid", label: "Balance" },
  { id: "createdAt", label: "Date" },
  { id: "status", label: "Status" },
];

const CustomerOrderPage = ({ orders }) => {
  let location = useLocation();
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();

  const [totals, setTotals] = useState({
    totalPaid: 0,
    totalUnpaid: 0,
  });

  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  useEffect(() => {
    let totalPaid = 0;
    let totalUnpaid = 0;
    orders?.forEach((order) => {
      // Ensure numeric values, defaulting to 0 if not present
      const orderPaid = parseFloat(order.paid) || 0;
      const totalOrderPrice =
        order.orderProducts?.reduce(
          (sum, product) => sum + (parseFloat(product.totalPrice) || 0),
          0
        ) || 0;

      totalPaid += orderPaid;
      totalUnpaid += totalOrderPrice - orderPaid;
    });
    setTotals({
      totalPaid: totalPaid.toFixed(2),
      totalUnpaid: totalUnpaid.toFixed(2),
    });
  }, [orders]);

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(orders, headCells, filterFn);

  const calculateTotalPrice = (data) => {
    let totalPrice = 0;
    if (data.length > 0) {
      data.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice);
      });
      return totalPrice.toFixed(2); // Return the total price rounded to 2 decimal places
    }
  };

  return (
    <div className="card">
      <Grid container>
        <Grid item xs={12} className="card__body">
          {loading ? (
            <Loading />
          ) : (
            <Paper style={{ overflowX: "auto" }}>
              <TblContainer>
                <TblHead />
                <TableBody>
                  {recordsAfterPagingAndSorting().length > 0 ? (
                    recordsAfterPagingAndSorting().map((item) => (
                      <TableRow key={item.id}>
                        <TableCell style={{ minWidth: "90px" }}>
                          {item.orderId
                            ? item.orderId
                            : `${item.id.slice(0, 7)}--`}
                        </TableCell>
                        <TableCell
                          className="page-table-cell hidden lg:table-cell"
                          style={{ minWidth: "140px" }}
                        >
                          <div className="page-assigned-to">
                            {item.staff?.fullName}
                          </div>
                        </TableCell>
                        <TableCell style={{ minWidth: "100px" }}>
                          {item?.orderProducts?.length > 0
                            ? formatNumber(calculateTotalPrice(item.orderProducts))
                            : 0}
                        </TableCell>
                        <TableCell
                          className="page-table-cell hidden sm:table-cell"
                          style={{ minWidth: "100px" }}
                        >
                          <div className="page-paid">
                            {formatNumber(item.paid || 0)}
                          </div>
                        </TableCell>
                        <TableCell className="page-table-cell hidden sm:table-cell">
                          <div
                            className={`page-balance ${
                              parseFloat(
                                (
                                  Number(
                                    calculateTotalPrice(item.orderProducts) || 0
                                  ) - Number(item.paid || 0)
                                ).toString()
                              ) < 0
                                ? "text-red-600"
                                : parseFloat(
                                    (
                                      Number(
                                        calculateTotalPrice(
                                          item.orderProducts
                                        ) || 0
                                      ) - Number(item.paid || 0)
                                    ).toString()
                                  ) > 0
                                ? "text-amber-600"
                                : "text-emerald-600"
                            }`}
                          >
                            {formatNumber(
                              Number(
                                calculateTotalPrice(item.orderProducts) || 0
                              ) - Number(item.paid || 0)
                            )}
                          </div>
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }}>
                          {new Date(item.createdAt).toLocaleString()}
                        </TableCell>
                        <TableCell className="page-table-cell">
                          {statusBadge(item.status || "Unknown")}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <Norecords col={6} />
                  )}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </Paper>
          )}
        </Grid>
      </Grid>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          flexDirection: "column",
          p: 1,
          m: 1,
          bgcolor: "background.paper",
          borderRadius: 1,
        }}
      >
        <Box p={1}>
          <span style={{ marginRight: "10px" }}>Total Paid</span>
          <TextField
            value={formatNumber(totals.totalPaid)}
            variant="outlined"
            disabled
            sx={{
              width: "200px",
              input: { padding: "6px 10px" },
            }}
          />
        </Box>

        <Box p={1}>
          <span style={{ marginRight: "10px" }}>Total Balance</span>
          <TextField
            value={formatNumber(totals.totalUnpaid)}
            variant="outlined"
            disabled
            sx={{
              width: "200px",
              input: { padding: "6px 10px" },
            }}
          />
        </Box>
      </Box>
    </div>
  );
};

export default CustomerOrderPage;
